// The specific reasons this module's backend gives, in the four languages.
//
// Two codes travel INSIDE an error and are not the code it is thrown with:
//
//   · `reasons` — what a generic refusal carries in `details.reason` or
//     `details.code` (`ConflictError(…, 'CONFLICT', { reason: 'ALREADY_CLOSED' })`).
//     errorMessage() says it from `errors.reasons.<REASON>` instead of the
//     generic «that record is no longer in the state you expected».
//   · `fields` — the code of each field of a ValidationError, said by
//     fieldErrors() from `errors.fields.<CODE>` instead of «not a valid value».
//
// Generic field codes (EMPTY, IN_THE_FUTURE, NOT_FOUND…) are the shell's and
// are not repeated here. platform/web/tests/errorReasons.test.js reads the
// backend and fails on a code without its four sentences, and on two
// modules saying one code differently (the shell merges them into one).

const errorReasons = {
  es: {
    reasons: {
      JUST_COMPLETED: 'Este plan se acaba de cerrar hace un momento',
    },
    fields: {
      METER_IMPLAUSIBLE: 'Esa lectura está demasiado lejos de la última para ser una lectura; la puede anotar quien gestiona el mantenimiento',
      BAD_METER: 'La lectura del contador no es válida',
      METER_REQUIRED: 'Este plan va por contador: falta la lectura',
      METER_WENT_BACK: 'Es menor que la lectura de la última vez',
    },
  },
  ca: {
    reasons: {
      JUST_COMPLETED: 'Aquest pla s’acaba de tancar fa un moment',
    },
    fields: {
      METER_IMPLAUSIBLE: 'Aquesta lectura és massa lluny de l’última per ser una lectura; la pot anotar qui gestiona el manteniment',
      BAD_METER: 'La lectura del comptador no és vàlida',
      METER_REQUIRED: 'Aquest pla va per comptador: falta la lectura',
      METER_WENT_BACK: 'És menor que la lectura de l’última vegada',
    },
  },
  en: {
    reasons: {
      JUST_COMPLETED: 'This plan was completed a moment ago',
    },
    fields: {
      METER_IMPLAUSIBLE: 'That reading is too far from the last one to be a reading; somebody who manages maintenance can file it',
      BAD_METER: 'That meter reading is not valid',
      METER_REQUIRED: 'This plan runs on a meter: the reading is missing',
      METER_WENT_BACK: 'Lower than the reading of the last time',
    },
  },
  fr: {
    reasons: {
      JUST_COMPLETED: 'Ce plan vient d’être clôturé à l’instant',
    },
    fields: {
      METER_IMPLAUSIBLE: 'Ce relevé est trop loin du dernier pour être un relevé ; quelqu’un qui gère la maintenance peut l’enregistrer',
      BAD_METER: 'Ce relevé de compteur n’est pas valide',
      METER_REQUIRED: 'Ce plan suit un compteur : le relevé manque',
      METER_WENT_BACK: 'Inférieur au relevé de la dernière fois',
    },
  },
}

/** The module's catalogue with these hung from `errors`, locale by locale. */
export function withErrorReasons(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    const own = errorReasons[locale] ?? {}
    merged[locale] = {
      ...catalogue,
      errors: {
        ...catalogue.errors,
        reasons: { ...catalogue.errors?.reasons, ...own.reasons },
        fields: { ...catalogue.errors?.fields, ...own.fields },
      },
    }
  }
  return merged
}

export default errorReasons
